import * as React from 'react';
import { CONTRACTS_AUTOCOMPLETE_QUERY } from '@/pages/contracts/contracts.gql';
import { GenericAutocomplete, AutocompleteConfig } from './generic-autocomplete';

export interface ContractAutocompleteItem {
	contractId: string;
	contractNumber: string;
	isActive: boolean;
	beginDate: string;
	endDate: string;
	customer?: {
		customerId: string;
		firmName?: string | null;
		firstName?: string | null;
		lastName?: string | null;
		isCompany?: boolean | null;
	} | null;
}

interface ContractAutocompleteProps {
	value?: string;
	onChange: (contractId: string, contract: ContractAutocompleteItem | null) => void;
	placeholder?: string;
	disabled?: boolean;
	className?: string;
	initialSelectedLabel?: string;
}

const getContractDisplayName = (contract: ContractAutocompleteItem): string =>
	contract.contractNumber;

const getContractSecondaryText = (contract: ContractAutocompleteItem): string => {
	const c = contract.customer;
	if (!c) return '';
	if (c.isCompany && c.firmName) return c.firmName;
	return [c.firstName, c.lastName].filter(Boolean).join(' ');
};

const contractAutocompleteConfig: AutocompleteConfig<ContractAutocompleteItem> = {
	query: CONTRACTS_AUTOCOMPLETE_QUERY,
	queryName: 'contracts',
	searchFields: ['contractNumber'],
	baseFilters: { isActive: { eq: true } },
	orderBy: [{ contractNumber: 'ASC' }],
	getDisplayName: getContractDisplayName,
	getSecondaryText: getContractSecondaryText,
	getId: (contract) => contract.contractId,
	pageSize: 20,
	enableDetails: true,
	entityType: 'contracts'
};

export const ContractAutocomplete: React.FC<ContractAutocompleteProps> = ({
	value,
	onChange,
	placeholder = 'Search contracts...',
	disabled = false,
	className = '',
	initialSelectedLabel
}) => (
	<GenericAutocomplete<ContractAutocompleteItem>
		config={contractAutocompleteConfig}
		value={value}
		onChange={onChange}
		placeholder={placeholder}
		disabled={disabled}
		className={className}
		initialSelectedLabel={initialSelectedLabel}
	/>
);
